import { Component, Host, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  trigger,
  transition,
  style,
  animate,
  query,
  group,
  state
} from '@angular/animations';
import { OnBoardComponent } from '../on-board.component';
import { OnBoardTransitionService } from 'src/app/_services/on-board-transition.service';
import { SettingService } from 'src/app/_services/admin/setting.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorUtil } from 'src/app/_utilities/error';
import { ProfileFeaturesService } from 'src/app/_services/profile-features.service';
import * as _ from 'lodash';

import { OnboardDataService } from 'src/app/_services/on-board-data.service';
import { ApiService } from 'src/app/_services/api.service';
import { AuthenticationService } from 'src/app/auth/authentication.service';
import { MixpanelService } from 'src/app/_services/mixpanel.service';
@Component({
    selector: 'app-customize-workspace',
    templateUrl: './customize-workspace.component.html',
    styleUrls: ['./customize-workspace.component.scss'],
    animations: [
        trigger('dotAnim', [
            state('inactive', style({
                transform: 'scale(1)',
                opacity: 0.5
            })),
            state('active', style({
                transform: 'scale(1.2)',
                opacity: 1
            })),
            transition('inactive => active', [
                animate('300ms ease-out')
            ]),
            transition('active => inactive', [
                animate('200ms ease-in')
            ])
        ])
    ],
    standalone: false
})
export class CustomizeWorkspaceComponent implements OnInit {
  modules = [
  {
    key: 'tasks',
    label: 'Tasks',
    desc: 'Create, assign and log action items',
    icon: 'assets/svg/workspace/Workspace-Task.svg',
    iconMenu: 'assets/svg/sidebar/task.svg',
    licensed: false
  },
  {
    key: 'site',
    label: 'Sites',
    desc: 'Manage multiple service locations',
    icon: 'assets/svg/workspace/Workspace-Sites.svg',
    iconMenu: 'assets/svg/sidebar/sites.svg',
    licensed: true
  },
  {
    key: 'job_order',
    label: 'Work Orders',
    desc: 'Schedule and track field jobs',
    icon: 'assets/svg/workspace/Workspace-WorkOrders.svg',
    iconMenu: 'assets/svg/sidebar/job-order.svg',
    licensed: false
  },
  {
    key: 'scheduled_maintenance',
    label: 'Preventive Maintenances',
    desc: 'Plan recurring or preventive services',
    icon: 'assets/svg/workspace/Workspace-Maintenance.svg',
    iconMenu: 'assets/svg/sidebar/pm-light.svg',
    licensed: true
  },
  {
    key: 'customers',
    label: 'Customers',
    desc: 'Store client details and history',
    icon: 'assets/svg/workspace/Workspace-Customer.svg',
    iconMenu: 'assets/svg/sidebar/customer.svg',
    licensed: false
  },
  {
    key: 'inventory',
    label: 'Inventory',
    desc: 'Track available parts and stock',
    icon: 'assets/svg/workspace/Workspace-Inventory.svg',
    iconMenu: 'assets/svg/sidebar/inventory-ic-1.svg',
    licensed: true // 🔒 Requires license
  },
  {
    key: 'assets',
    label: 'Assets',
    desc: 'Register and monitor key equipment',
    icon: 'assets/svg/workspace/Workspace-Assets.svg',
    iconMenu: 'assets/svg/sidebar/desktop.svg',
    licensed: false
  },
  {
    key: 'project',
    label: 'Projects',
    desc: 'Group work under major initiatives',
    icon: 'assets/svg/workspace/Workspace-Projects.svg',
    iconMenu: 'assets/svg/sidebar/project.svg',
    licensed: false
  },
  {
    key: 'products',
    label: 'Spare Parts',
    desc: 'Link parts to jobs and assets',
    icon: 'assets/svg/workspace/Workspace-SpareParts.svg',
    iconMenu: 'assets/svg/sidebar/product-ic-1.svg',
    licensed: false
  },
  {
    key: 'assets_contracts',
    label: 'Contracts',
    desc: 'Manage asset terms and warranties',
    icon: 'assets/svg/workspace/Workspace-Contracts.svg',
    iconMenu: 'assets/svg/sidebar/contracts-light.svg',
    licensed: false
  },
  {
    key: 'checklists',
    label: 'Checklists',
    desc: 'Standardize work and inspections',
    icon: 'assets/svg/workspace/Workspace-Checklists.svg',
    iconMenu: 'assets/svg/sidebar/productivity-icon.svg',
    licensed: false
  },
  {
    key: 'requisitions',
    label: 'Requisitions',
    desc: 'Request, approve, and track parts',
    icon: 'assets/svg/workspace/Workspace-Requisitions.svg',
    iconMenu: 'assets/svg/sidebar/inventory-ic-1.svg',
    licensed: true
  },
];

selectedModules: any[] = [];
copy_selectedModules: string[] = [];

currentStep = 3;
  moduleSetupFeatureData: any[] = [];
  tenantPackages: any;
  companyName: string;
  permissions!: { role: any; roles: any[]; };
  submitTouched: boolean;
fromSubmitData:any={
  
    "company": "Arfan edited name 45",
    "industry":null,
    "featureOptions":[]
  
}
packageCode: string;

  constructor(
    private router: Router,  
    private transitionService: OnBoardTransitionService,
   private settingsService : SettingService, 
    private spinner:NgxSpinnerService,
   private errorUtil: ErrorUtil,
  private perm: ProfileFeaturesService,
private auth: AuthenticationService,
private mixPanelService: MixpanelService,
private apiService: ApiService) { }

  ngOnInit(): void {
    this.companyName = localStorage.getItem('setupOrg_home') || 'Sample Company';
    this.fromSubmitData.company = this.companyName;
    this.fromSubmitData.industry =  JSON.parse(localStorage.getItem('selectedIndustry') )|| null;
    this.getSetupFeatures();
    this.packageCode = localStorage.getItem('packageCode')
  }
   getSetupFeatures(){
    
        this.spinner.show();
        this.settingsService.getSetupFeatures().subscribe((response:any) => {
           this.moduleSetupFeatureData = response; // Assuming response is an array of industry details
           console.log(this.moduleSetupFeatureData, "moduleSetupFeatureData");
            if(this.moduleSetupFeatureData.length > 0){
             this.moduleSetupFeatureData.forEach((element: any) => {
            const match = this.modules.find(ind => ind.key === element.internalName);

            if (match) {
                // If a match is found, update the element with the matched data
                element.key = element.internalName,
                element.label= match.label,
                element.desc= match.desc,
                element.icon= match.icon,
                element.iconMenu= match.iconMenu;
                element.enabled = element.enabled; // Default to false if not specified
                element.disabled =false; // Handle disabled state if specified
                 }else{
              // If no match found, you can handle it here
             console.warn(`No match found for industry key: ${element.internalName}`);
              // Optionally, you can set default values or handle it as needed
                element.key = element.internalName,
                element.label= element.name,
                element.desc= 'Sample Description',
                element.icon= 'assets/svg/workspace/Workspace-Tasks.svg',
                element.iconMenu= 'assets/svg/sidebar/task.svg';
                element.enabled = element.enabled// Default to false if not specified
                element.disabled = false; // Handle disabled state if specified
             }
            if(element.available && element.enabled){ // Check if the module is available and enabled
            this.selectedModules.push(element); // Add the key to selectedModules
          }
          });

          this.copy_selectedModules = [...this.selectedModules];

           } else {
            this.moduleSetupFeatureData = this.modules; // Fallback to default industries if no data is returned
           }
           
        })   
  }
  

getModuleByKey(key: any) {
 return this.moduleSetupFeatureData.find(m => m.key === key);
}

toggleModule(element: any,index: number) {
  if(!element.available) {
    return; // Exit if the module is not available
  }
  if (element.internalName === 'tasks' || element.internalName === 'customers' || element.internalName === 'job_order'){
    return; //Exist if the module is Task or Customer or Job Order (not allowed to uncheck)
  }
  element.enabled = element.enabled ? false:true; // Toggle the enabled state
  
  if(element.enabled) {
    //this.selectedModules.push(element);

    //original index of incoming item (element)
    let oriElementIndex: number = this.copy_selectedModules.findIndex(
      (module: any) => module.key === element.key
    );

    //original index of last item in current selectedModules array
    let oriIndexLastItem: number = this.copy_selectedModules.findIndex(
      (module: any) => module.key === this.selectedModules[this.selectedModules.length-1]?.key //last item in current selectedModules
    );
  
      let newIdx: number;
      //check whether element is supposed to be inserted after the exisiting array or before the exisiting array
      if (oriElementIndex < oriIndexLastItem){
        //before
        if (oriElementIndex > this.selectedModules.length){
          newIdx = this.selectedModules.length - oriElementIndex; //consider the incoming index (oriElementIndex) is greater than the exisiting indexes of selectedModules
          this.selectedModules.splice(newIdx, 0, element);
        }
        else if (oriElementIndex < this.selectedModules.length){//consider the incoming index (oriElementIndex) is less than the exisiting indexes of selectedModules
          newIdx = oriElementIndex;
          this.selectedModules.splice(newIdx, 0, element);

          //original index of the item which is located jux before the incomming item(element) in current selectedModules array 
          let oriOneBeforeElementIndex: number = this.copy_selectedModules.findIndex(
            (module: any) => module.key === this.selectedModules[newIdx-1]?.key
          );

          //e.g: if Job Order is located before Spare Part in current selectedModules while Spare Part is the incoming element to be enabled
          //check the one before. If the one before's index (in selectedModules array) is less, then rearrange (take the less one )
          if (oriOneBeforeElementIndex > newIdx ){
            this.selectedModules.splice(newIdx, 1);//delete it first before adding
            this.selectedModules.splice(newIdx-1, 0, element);
          }
        }
        else{
          newIdx = this.selectedModules.length - 1; //consider the incoming index (oriElementIndex) is equal to the length of the selectedModules
          this.selectedModules.splice(newIdx, 0, element);
        }
      }
      else{
        //after
        this.selectedModules.push(element);
      }

    const newElement = this.moduleSetupFeatureData.find(
      (mod: any) => mod.key === element.key
    );

  }
  else {
    const removeIndex = this.selectedModules.findIndex(
      (mod: any) => mod.key === element.key
    );
    const newElement = this.moduleSetupFeatureData.find(
      (mod: any) => mod.key === element.key
    );

    if (removeIndex > -1) {
      this.selectedModules.splice(removeIndex, 1);
    } // Remove the module from selectedModules if disabled
  }
}

isSelected(key: any): boolean {
  return this.selectedModules.some((m: any) => m.key === key);
}
goToPrevious() {
    this.transitionService.startTransition('select-industry');
}

  /******************************************** Get Profile Features ******************************************/
  getProfileFeature() {
    try {
      this.perm.getProfileFeatures().subscribe(permissionResponse=>{

        if(permissionResponse){
          localStorage.setItem('role_token', btoa(permissionResponse.profile.name));
          this.permissions = {role : permissionResponse.profile.name, roles : []}
          permissionResponse.moduleAccessFeatures.forEach((role:any) => {

            var tempRole = {
              moduleName : role.feature.internalName || role.feature.name,
              read : role.readFeature,
              create : role.createFeature,
              update : role.updateFeature,
              remove : role.deleteFeature
            }
            this.permissions.roles.push(tempRole);
          });

          console.log(permissionResponse);

          permissionResponse.adminSettingsFeatures.forEach((role2: any )=> {
            if(role2.typeValue === 'YES'){
              var tempRole = {
                moduleName : role2.feature.internalName || role2.feature.name,
                read : true,
                create : true,
                update : true,
                remove : true
              }
            } else {
              if(role2.feature.internalName === 'manage_org_detail'){
                var findSetup = _.filter(permissionResponse.moduleAccessFeatures, function(o) { return o.feature.name == 'setup'; })
                if(findSetup.length){
                  var tempRole = {
                    moduleName : role2.feature.internalName,
                    read : false,
                    create : false,
                    update : false,
                    remove : false
                  }
                } else {
                  var tempRole = {
                    moduleName : role2.feature.internalName,
                    read : false,
                    create : false,
                    update : false,
                    remove : false
                  }
                }
              } else {
                var tempRole = {
                  moduleName : role2.feature.internalName,
                  read : false,
                  create : false,
                  update : false,
                  remove : false
                }
              }
            }
            this.permissions.roles.push(tempRole);
          });

          if(permissionResponse.profile.allowAssignTask){
            var tempRole = {
              moduleName : 'allow assign task',
              read : true,
              create : true,
              update : true,
              remove : true
            }
          } else {
            var tempRole = {
              moduleName : 'allow assign task',
              read : false,
              create : false,
              update : false,
              remove : false
            }
          }
          this.permissions.roles.push(tempRole);

          if(permissionResponse.profile.binUser){
            var tempRole = {
              moduleName : 'bin user',
              read : true,
              create : true,
              update : true,
              remove : true
            }
          } else {
            var tempRole = {
              moduleName : 'bin user',
              read : false,
              create : false,
              update : false,
              remove : false
            }
          }

          if(permissionResponse.profile.helpDeskUser){
            var tempRole = {
              moduleName : 'helpdesk user',
              read : true,
              create : true,
              update : true,
              remove : true
            }
          } else {
            var tempRole = {
              moduleName : 'helpdesk user',
              read : false,
              create : false,
              update : false,
              remove : false
            }
          }

          this.permissions.roles.push(tempRole);

          if(permissionResponse.profile.allowViewSalesorderPrice){
            var tempRole = {
              moduleName : 'allow view sales order price',
              read : true,
              create : true,
              update : true,
              remove : true
            }
          } else {
            var tempRole = {
              moduleName : 'allow view sales order price',
              read : false,
              create : false,
              update : false,
              remove : false
            }
          }

          this.permissions.roles.push(tempRole);
          var menuPermissions = {
            defaultTenantCategory : permissionResponse.profile.defaultTenantCategory.toLowerCase(),
            sales : permissionResponse.profile.sales,
            service : permissionResponse.profile.service,
            fleet : permissionResponse.profile.fleet
          }
          ////
          localStorage.setItem('permissions', JSON.stringify(this.permissions));
          //update the local storage (FOR THE PURPOSE OF NEW USER ONBOARDING. NEED TO USE dataLoadPerformed FROM HERE WHEN CHECKING THE FLAG IN app.component ON LOAD)
          this.apiService.getProfile().subscribe( (profileResponse: any)=> {
            if (profileResponse){
              var profile = {
                firstName: profileResponse.firstName,
                fullName:
                  profileResponse.firstName + " " + profileResponse.lastName,
                email: profileResponse.email,
                tenantId: profileResponse.tenantId,
                tenantCategories: profileResponse.tenantCategories,
                createdDate: profileResponse.licenceVM.createdDate,
                renewalDate: profileResponse.licenceVM.validTill,
                trial: profileResponse.licenceVM.trial,
                billingUser: profileResponse.billingUser,
                dataLoadPerformed: profileResponse.dataLoadPerformed,
                isCustomerPortalEnabled:
                  profileResponse.isCustomerPortalEnabled,
              };
            }
            localStorage.setItem('profile_info', btoa(JSON.stringify(profile)));
          });
          
          this.getAnalyticsBrowser();
          this.router.navigate(['/dashboard/onBoard/get-started']); //If the user is created via website is true and addon is ONBOARD, redirect to onboarding page
        }
      });
    } catch (error) {
      console.error(error);
    }
  }

  /****************************************** Submit Data *****************************/
  onSubmitForm(){
   if(this.selectedModules.length == 0){
      this.errorUtil.setErrorMessage(400, 'Please select at least one module to proceed. ' ,  null, 'error',3000);
      return;
    }
    this.submitTouched = true;
    this.spinner.show();
var featureOptions = [];
    this.selectedModules.forEach((element: any) => {
        featureOptions.push(element);
      
    });
  
    var req ={
      "company": this.fromSubmitData.company,
      "industry": this.fromSubmitData.industry,
      "featureOptions": this.moduleSetupFeatureData
    }
   
  console.log(req)
    this.settingsService.setSetupFeatures(req).subscribe((res:any) => {
      console.log(res.body)
      if(res.status == 201 || res.status == 200){
        this.getProfileFeature();
     //  this.errorUtil.setErrorMessage(200, this.translate?.general.messages.savedSuccessfully ,  null, 'success',1000);
     
      } else {
        this.errorUtil.setErrorMessage(res.status, null ,  res.error, 'error',3000);
        this.submitTouched = false;
      }
    },
    (err) => {
      this.spinner.hide()
     this.errorUtil.setErrorMessage(err.status, null ,  err.error, 'error',3000);
    
  })
  }
getAnalyticsBrowser() {
  //Mixpanel Event Tracking
  if(localStorage.getItem('packageCode') != null && localStorage.getItem('packageCode') != 'Old'){
    this.mixPanelService.track('w_onboard_setmodules', { propertyName: 'w_onboard_setmodules', method: 'button_click'});
  }
}
}
